<template>
	<div id="livePlayback" class="page">
		<v-header :selectedItemVal="0" style="background:white"></v-header>

		<div class="main">
			<div class="page_tag">
			        首页 &nbsp;> &nbsp; 回放
			</div>
			<div class="video_kanban">
				<div class="prism-player" id="livePlaybackKanban"></div>
			</div>
			<div class="enclosure" v-if="playbackItem.imageList ? playbackItem.imageList.length : 0">
			    <div>附件:</div>
				<div class="enclosure-box">
					<span v-for="(item,index) in playbackItem.imageList" @click="downloadEnclosure(item)">{{item.imgeName}}</span>
				</div>
			</div>
		</div>

		<v-footer></v-footer>
	</div>
</template>

<script>
import vHeader from '../common/header'
import vFooter from '../common/footer'
import vPlayback from '../common/playback'
export default {
	name: "livePlayback",
	data() {
		return {
			lvrrId: 0,
			playbackItem: {},
			videoPlayUrl: '',
			liveEnclosure: [],
			aliPlayer: {},
			aliPlayerOptions: {
				width: '100%',
				height: '663px',
			},
		}
	},
	components: {
		'v-header': vHeader,
		'v-footer': vFooter,
		'v-playback': vPlayback,
	},
	mounted() {
		//+-------------更新回放ID--------------------
		this.lvrrId = this.$route.query.lvrrId;
		//+------------获取录播详情-------------------
		this.getDetail();
	},
	methods: {
		//获取录播详情
		getDetail() {
			//+----------------构建请求参数----------------
			let data = {
				lvrrId: this.lvrrId,
			};
			//+---------------获取录播回放详情-------------
			this.apiServer.live.getPlaybackDetail(this.qs.stringify(data))
				.then(res => {
					if (res.data.code == 200) {
						if (res.data.data.businessCode != 10) {
							this.$message.error(res.data.data.businessMessage);
							return false;
						}

						//+----------------回放加锁无法观看-----------------------
						if (res.data.data.lockStatus == 1) {
							this.videoPlayUrl = null;
							this.$message.error('暂无观看权限');
							this.aliPlayer.dispose();
							return false;
						}

						//更新录播数据
						this.playbackItem = res.data.data;

						//初始化播放器
						this.aliPlayerInit();
					}
				})
				.catch(error => {
					console.log('获取回放详情异常', error);
				});
		},
		//下载附件
		downloadEnclosure(item) {
			//访问附件地址
			window.location.href = item.imgeUrl;
		},
		//阿里web播放器
		aliPlayerInit() {
			var _this = this;
			// 初始化播放器
			this.aliPlayer = new Aliplayer({
				id: "livePlaybackKanban", 				// 容器id
				source: this.playbackItem.lvrrVideo,	//视频地址
				width: this.aliPlayerOptions.width,		// 播放器宽度
				height: this.aliPlayerOptions.height,	// 播放器高度
				autoplay: true,							// 是否自动播放
				isLive: false,							//是否直播
				cover: this.playbackItem.lvrrSmallImg,  //播放器封面图
				rePlay: false,
				playsinline: true,
				preload: true,
				controlBarVisibility: "hover",
				useH5Prism: true,
				components: [
					// {
					// 	name: 'PreviewVodComponent',
					// 	type: AliPlayerComponent.PreviewVodComponent,
					// 	/* 第一个参数是试看时长, 单位为分钟 */
					// 	/* 第二个参数可以传一个 Dom 字符串, 他将会替换默认的'试看已结束...'等文字 */
					// 	args: [60, '#endPreviewTemplate', `<a href="https://www.aliyun.com/product/vod" class="vip-join">开通会员</a> 观看完整视频`]
					// },
					// {
					// 	name: 'MemoryPlayComponent',
					// 	type: AliPlayerComponent.MemoryPlayComponent,
					// 	// args:[true,getTime,saveTime]
					// },
					// {
					// 	name: 'RotateMirrorComponent',
					// 	type: AliPlayerComponent.RotateMirrorComponent
					// }
				],
				"skinLayout": [
					{ name: "bigPlayButton", align: "blabs", x: 50, y: 60 },
					{ name: "H5Loading", align: "cc" },
					{ name: "errorDisplay", align: "tlabs", x: 0, y: 0 },
					{ name: "infoDisplay" },
					{ name: "tooltip", align: "blabs", x: 0, y: 56 },
					{ name: "thumbnail" },
					{
						name: "controlBar", align: "blabs", x: 0, y: 0,
						"children": [
							{ name: "progress", align: "blabs", x: 0, y: 44 },
							{ name: "playButton", align: "tl", x: 15, y: 12 },
							{ name: "timeDisplay", align: "tl", x: 10, y: 7 },
							{ name: "fullScreenButton", align: "tr", x: 10, y: 12 },
							{ name: "volume", align: "tr", x: 5, y: 10 }
						]
					}
				]
			}, (aliPlayer) => {
				// console.log('播放器创建成功');
				console.log('测试', aliPlayer);
				//+----------------------------自定义video样式----------------------------------
				aliPlayer.tag.attributes.style.value = 'width:100%;height:100%;object-fit: cover;border-radius:12px';
			});

			this.aliPlayer.on('ready', () => {
				// console.log('视频可播放')

			});

			this.aliPlayer.on('pause', () => {
				// console.log('播放暂停');

			});

			this.aliPlayer.on('ended', function (e) {
				// console.log('播放结束');
			});

			this.aliPlayer.on('error', function (e) {
				// console.log('播放异常');
			});

			// 播放位置发生改变时触发，仅H5播放器
			this.aliPlayer.on('timeupdate', () => {
				let time = this.aliPlayer.getCurrentTime() // 获取播放的时间
				// console.log('视频播放位置变更',time)
			});

			this.aliPlayer.on('ended', () => {
				// console.log('播放结束');
			});

			this.aliPlayer.on('onM3u8Retry', function () {
				// console.log('主播暂时离开，请稍后......');
			});

			this.aliPlayer.on('liveStreamStop', () => {
				// console.log('直播失败或已结束');

				//切换直播流
				// this.aliPlayer.loadByUrl();
			});
		}
	}
}
</script>

<style scoped>
.main {
	width: 1250px;
	border-radius: 12px;
	margin: 0 auto;
}

.page_tag {
	margin-top: 15px;
	height: 30px;
	font-size: 24px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 600;
	color: #222222;
	line-height: 30px;
	margin-bottom: 15px;
}

.video_kanban {
	border-radius: 12px;
	background-color: #000000;
	padding: 5px;
}

.livePlaybackKanban {
	border-radius: 12px !important;
}

.enclosure {
	font-size: 30px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #222222;
	display: inline-flex;
	flex-direction: column;
	line-height: 42px;
	margin-bottom: 21px;
}

.enclosure-box {
	display: flex;
	flex-direction: column;
}

.enclosure span {
	color: red;
	cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/live/livePlayback.vue